import { createSelector, DefaultProjectorFn, MemoizedSelector } from '@ngrx/store';

import { AppState } from '../app.state';

import { InstallationsSearchState, SearchedParams } from './installations-search.state';
import { Gateway } from '../installation-details';

export namespace InstallationsSearchSelectors {
  export const installationSearch = (state: AppState): InstallationsSearchState =>
    state.installationsSearch;

  export function getState(): MemoizedSelector<
    AppState,
    InstallationsSearchState,
    DefaultProjectorFn<InstallationsSearchState>
  > {
    return createSelector(installationSearch, (state: InstallationsSearchState) => state);
  }

  export const searchedParams = (installationSearch: InstallationsSearchState): SearchedParams =>
    installationSearch.searchParams;

  export function filteredGateway(): MemoizedSelector<
    AppState,
    Gateway[],
    DefaultProjectorFn<Gateway[]>
  > {
    return createSelector(installationSearch, (state: InstallationsSearchState) => {
      const gatewayArr = [];
      const allGateways = state?.installations;
      const boilerSerial = state.searchParams?.boilerSerial.trim();

      allGateways.forEach((installation) => {
        const gateways = installation.gateways;
        if (gateways?.length > 0 && boilerSerial) {
          const foundGateway = gateways.find((gateway) =>
            gateway.devices.some((device) => device?.boilerSerial === boilerSerial)
          );
          gatewayArr.push(foundGateway) || null;
        }
      });

      return gatewayArr.length ? gatewayArr : null;
    });
  }
}
